<template>
  <div id="app">
    <!-- my-auth always needs to be placed in the first position -->
    <my-auth></my-auth>
    <transition name="fade" mode="out-in" appear>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import MyAuth from '@/pages/MyAuth'
export default {
  name: 'app',
  components: {
    MyAuth
  },
  created: function () {
    this.$auth.removeTokensFromLegacyLocation() // TODO - remove this at 2019-03-01
    if (!this.$route.query['ip_auth_dealer']) {
      this.$store.commit('LOAD_LAST_SESSION') // set id_token in auth service before "Set Session" takes its place.
    }
  }
}
</script>

<style>
:root {
    --primary: #1e88e5;
    --primary-shade: #1a78ca;
    --primary-tint: #3594e8;
    --secondary: #5469d4;
    --secondary-shade: #4a5cbb;
    --secondary-tint: #6578d8;
    --success: #1ea675;
    --success-shade: #1a9267;
    --success-tint: #35af83;
    --warning: #f5925e;
    --warning-shade: #d88053;
    --warning-tint: #f69d6e;
    --danger: #cd3d64;
    --danger-shade: #b43658;
    --danger-tint: #d25074;
    --gray-high: #212121;
    --gray-medium: #666;
    --gray-low: #9e9e9e;
    --blue-gray-higher: #55647b;
    --blue-gray-high: #8792a2;
    --blue-gray-medium: #e3e8ee;
    --blue-gray-low: #f7fafc;
    --border: #e6e6e6;
}

body {
  margin: 0;
  padding: 0;
  user-select: none;
}

#app {
  font-family: Roboto, sans-serif, Helvetica;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  width: 100%; 
  height: 100%; 
  position: absolute; 
  touch-action: manipulation;
}

/* input style */
input {
  /* Remove First */
  -webkit-appearance: none;
  -moz-appearance: none;

  /* Then Style */
  font-size: 1em;
  border-radius: 0px;
  width: 100%;
  padding: 0px;
  border: 0px solid #666;
  outline: none;
  color: #000;
  background-color: transparent;
}

input::placeholder {
  opacity: 0.5;
}

/* useful styles */
.vertical-center {
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}


/* scroll bar style */
/* .scrollable {
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: ms-autohiding-scrollbar;
  overflow: hidden;
}
.scrollable.-x {
  overflow-x: auto;
}
.scrollable.-y {
  overflow-y: auto;
}
.scrollbar-hidden::-webkit-scrollbar {
  display: none;
}
::-webkit-scrollbar {
  width: 16px;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px 0 hsla(0,0%,70%,0);
  background-color: hsla(0, 0%, 100%, 0);
  border-radius: 0px;
}
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: hsla(200,0%,40%,1);
  border: 4px solid transparent;
  background-clip: content-box;
}
::-webkit-scrollbar-thumb:hover {
  background-color: hsla(200,0%,20%,1);
}
::-webkit-scrollbar-thumb:window-inactive {
  background-color: hsla(200,0%,60%,1);
} */


/* spinner */
/* <div class="spinner"><div></div><div></div><div></div><div></div></div> */
.spinner {
  display: inline-block;
  position: relative;
  width: 54px;
  height: 54px;
}
.spinner div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 41px;
  height: 41px;
  margin: 6px;
  border: 6px solid #fff;
  border-radius: 50%;
  animation: spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.spinner div:nth-child(1) {
  animation-delay: -0.45s;
}
.spinner div:nth-child(2) {
  animation-delay: -0.3s;
}
.spinner div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


/* global animation */
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.text-enter-active, .text-leave-active {
  transition: all .5s;
}
.text-enter, .text-leave-to /* .fade-leave-active below version 2.1.8 */ {
  font-size: 0px;
}

.flyIn-enter-active, .flyIn-leave-active {
  transition: opacity 1.5s, transform .5s;
}
.flyIn-enter, .flyIn-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(300px) scale(0.1);
}

.flyInH-enter-active, .flyInH-leave-active {
  transition: opacity .5s, transform .5s;
}
.flyInH-enter /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(100%);
}
.flyInH-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-100%);
}

.slideIn-enter-active, .slideIn-leave-active {
  transition: opacity .5s, transform .5s;
}
.slideIn-enter /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(100%);
  position: absolute;
  top: 0;
}
.slideIn-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-100%);
  position: absolute;
  top: 0;
}

:root {
  --primary: #1e88e5;
  --primary-shade: #1a78ca;
  --primary-tint: #3594e8;
  --secondary: #5469d4;
  --secondary-shade: #4a5cbb;
  --secondary-tint: #6578d8;
  --success: #1ea675;
  --success-shade: #1a9267;
  --success-tint: #35af83;
  --warning: #f5925e;
  --warning-shade: #d88053;
  --warning-tint: #f69d6e;
  --danger: #cd3d64;
  --danger-shade: #b43658;
  --danger-tint: #d25074;
  --gray-high: #212121;
  --gray-medium: #666;
  --gray-low: #9e9e9e;
  --blue-gray-higher: #55647b;
  --blue-gray-high: #8792a2;
  --blue-gray-medium: #e3e8ee;
  --blue-gray-low: #f7fafc;
  --border: #e6e6e6;
}

.card-container {
  box-shadow: 0 0 20px 0 rgba(227,232,238,.42745098039215684);
  border: 1px solid var(--blue-gray-medium);
  border-radius: 5px;
  padding: 2rem;
  transition: 0.3s ease all;
}

.card-container:hover {
  box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue